const state = {
  // this will hold data of all widgets
  iframeScrollPosition: 0,
};

const getters = {
  getScrollPosition(state) {
    return state.iframeScrollPosition;
  }
};

const mutations = {
  setScrollPosition(store, scrollPosition) {
    store.iframeScrollPosition = scrollPosition;
  }
};

const actions = {
  dialog({ commit }) {
    commit('reset');
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
